'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const components_marketing_ZapCard_ZapCard = require('../ZapCard/ZapCard.cjs.js');
require('../ZapCard/ZapCardDetails.cjs.js');
const theme_Colors = require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
require('../../../theme/Typography.cjs.js');
require('react');

const zapcardSection = "_zapcard-section_bczyy_1";
const styles = {
	zapcardSection: zapcardSection
};

const breakpoints = {
  tablet: 768,
  desktop: 1230
};
const Styles = styleEncapsulation.labelStyles("ZapCardSection", {
  root: react.css`
    padding: 20px;

    @media screen and (min-width: ${breakpoints.tablet}px) {
      padding: 20px 30px;
    }

    @media screen and (min-width: ${breakpoints.desktop}px) {
      padding: 40px;
    }
  `,
  container: (layout) => react.css`
    display: grid;
    gap: 30px;
    grid-template-columns: ${layout === "auto" ? "1fr" : "repeat(auto-fit, minmax(235px, 1fr))"};
    margin: 0 auto;
    max-width: 1170px;
  `
});
const ZapCardSection = ({ items, layout = "card" }) => {
  var _a;
  if (items.length > 3 && layout !== "auto") {
    console.error("Max 3 items are allowed in ZapCardSection component");
  }
  const maxItems = layout === "auto" ? items.length : 3;
  return react.jsx(
    "div",
    { css: Styles.root, className: styles.zapcardSection, "data-zds": true },
    react.jsx("div", { css: Styles.container(layout), "data-zds": true }, (_a = items === null || items === void 0 ? void 0 : items.slice(0, maxItems)) === null || _a === void 0 ? void 0 : _a.map((_a2) => {
      var { color = theme_Colors.Colors.PrimeWhite, href } = _a2, rest = tslib_es6.__rest(_a2, ["color", "href"]);
      return react.jsx(components_marketing_ZapCard_ZapCard.ZapCard, Object.assign({}, rest, { color, href, layout }));
    }))
  );
};

exports.ZapCardSection = ZapCardSection;
//# sourceMappingURL=ZapCardSection.cjs.js.map
